import React from "react";
import { useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const { currentUser } = useSelector((state) => state.user);

  return (
    <div>
      {currentUser ? (
        <Outlet />
      ) : (
        <>
          <h1>Sign In To View This Page</h1>
          {/* <Link to="sign-in">Sign In</Link> */}
        </>
      )}
    </div>
  );
};

export default PrivateRoute;
